import { useSelector } from "react-redux";
import { _ } from "src/services";
import { TvModel } from "src/store";
import { TvConductorListSearch } from "./tv.conductor.list.search";
import { TvConductorProgramCard } from "./tv.conductor.program.card";
import { TvConductorProgramCardShimmer } from "./tv.conductor.program.card.shimmer";

export const TvConductorListMobile: React.FC = () => {

    //#region Dependencies

    const conductor: TvModel = useSelector((state: any) => state.TvState);

    //#endregion

    //#region properites

    const filtered = conductor.conductor.filter((x) => x.title.indexOf(conductor.searchText || "") > -1);

    //#endregion


    //#region helpers

    const renderPrograms = () => {

        if (conductor.conductorLoading && !conductor.conductor.length) {
            return (
                [...new Array(10)].map((item, index) => (
                    <TvConductorProgramCardShimmer key={index} />
                ))
            );
        }

        if (!conductor.channelsLoading && !filtered.length) {
            return (
                <div className="col-12 text-center text-rtl">
                    <div className="no-result-title mt-2 mt-md-4 mb-5 mb-md-0">
                        {_("noProgramMessage")}
                    </div>
                </div>
            );
        }

        return (
            filtered.map((item) => (
                <TvConductorProgramCard key={item.id} {...item} />
            ))
        );

    };

    //#endregion

    if (!conductor.showConductor) return null;

    return (
        <div className="col-12 col-lg-3 programs-list d-lg-none d-block">
            <h1 className="title">
                {`${_("programList")}${conductor.currentChannel?.title ? "ی" + conductor.currentChannel?.title : ""}`}
            </h1>
            <TvConductorListSearch />
            <div>
                {renderPrograms()}
            </div>
        </div>
    );
};